import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getProjectMembers,
  addProjectMembers,
  removeProjectMember,
} from "@/lib/time-api";
import { useOrgId } from "@/lib/org-context";

export function useProjectMembers(projectId: string | undefined) {
  const qc = useQueryClient();
  const orgId = useOrgId();
  const queryKey = ["project-members", orgId, projectId];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => getProjectMembers(projectId!),
    enabled: !!orgId && !!projectId,
  });

  const add = useMutation({
    mutationFn: (memberIds: string[]) => addProjectMembers(projectId!, memberIds),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: (memberId: string) => removeProjectMember(projectId!, memberId),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  });

  return {
    members: data?.members ?? [],
    loading: isLoading,
    add,
    remove,
  };
}
